/**
 * NavLogViewerPanel — wrapper that provides nav log data from useFlightPlan hook.
 */
import { NavLogViewer } from './NavLogViewer';
import { useFlightPlan } from '../services/FlightPlanContext';

export function NavLogViewerPanel() {
  const { currentPlan } = useFlightPlan();
  return <NavLogViewer navLog={currentPlan?.navLog ?? null} onClose={() => {}} />;
}
